$(() => {
  const pluginName = 'teamsPlugin';
  const dataKey = `plugin_${pluginName}`;

  let settings = {};
  let $pluginContainer = null;
  let $teamStates;
  let $teamSpinner;

  /**
   * Clear out the existing team containers
   */
  const clearContainers = () => {
    $pluginContainer
      .find([
        '.js-team-categories',
        '.js-team-create-new',
        '.js-team-join-existing',
        '.js-team-join-reserved',
        '.js-team-questions',
        '.js-team-preferred-fundraising-organization-display',
      ].join(', '))
      .empty();
  };

  const clearPreferredFundraisingContainer = () => {
    $pluginContainer.find('.js-team-preferred-fundraising-organization-display').html('').addClass('hidden');
  };

  /**
   * Show the team spinner
   */
  const showLoadingState = () => {
    $teamSpinner.removeClass('hidden');
    $pluginContainer.find('[data-js-team-state-selector-fieldset]').prop('disabled', true);
  };

  /**
   * Hide the team spinner
   */
  const hideLoadingState = () => {
    $teamSpinner.addClass('hidden');
    $pluginContainer.find('[data-js-team-state-selector-fieldset]').prop('disabled', false);
  };

  /**
   * Run the questions plugin but like only if it should
   * @param $element
   */
  const initializeTeamQuestions = ($element) => {
    if (!$element) {
      return;
    }

    if (!$element.length) {
      return;
    }

    // hack to get the JS to wait for DOM update before doing things
    $element[0].getBoundingClientRect();

    if (!$element.children().length) {
      return;
    }

    $element.questionsPlugin({
      registrationPlugin: settings.registrationPlugin,
      i18n: settings.i18n,
      eventCountry: settings.eventCountry,
      registrantIndex: settings.registrantIndex,
      registrantsPersonalInformation: settings.registrantsPersonalInformation,
    });
    $element.questionsPlugin('initializeContent');
  };

  /**
   * Validate the team name during creation for the registrant
   */
  const validateTeamName = function validateTeamName() {
    const $this = $(this);
    const $teamNameContainer = $this.closest('.form-group');
    const $teamNameFeedback = $teamNameContainer.find('.js-team-name-feedback');
    const $teamNameFeedbackIcon = $teamNameContainer.find('.js-team-name-feedback-icon');

    $teamNameContainer.removeClass('has-success has-error');
    $teamNameFeedbackIcon.removeClass('fa-check-circle fa-times-circle hidden').addClass('fa-spinner fa-pulse');
    $teamNameFeedback.addClass('hidden').empty();

    $.ajax({
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/name`,
      type: 'POST',
      data: {
        name: $this.val(),
      },
    })
      .always(() => {
        $teamNameFeedbackIcon.removeClass('fa-check-circle fa-times-circle fa-spinner fa-pulse');
      })

      .done(() => {
        $teamNameFeedbackIcon.addClass('fa-check-circle');
        $teamNameContainer.addClass('has-success');
      })

      .fail((response) => {
        $teamNameFeedbackIcon.addClass('fa-times-circle');
        $teamNameContainer.addClass('has-error');
        $teamNameFeedback.removeClass('hidden').text(response.responseJSON.errors['team-name']);
      });
  };

  /**
   * Load the category selector for joining existing and creating
   *
   * @param teamState
   */
  const loadCategories = (teamState) => {
    showLoadingState();

    $.ajax({
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/${teamState}`,
      type: 'GET',
    })
      .always(() => hideLoadingState())

      .done((response) => {
        const $categoriesContainer = $pluginContainer.find('.js-team-categories').html(response);
        const $categories = $categoriesContainer.find(':input[name="teams[category]"]');
        const $selectableCategories = $categories.find('option:enabled');

        // If there is only one category, pick it for them
        if ($selectableCategories.length === 1) {
          $categories.val($selectableCategories.val());
        }

        // Trigger the change in case the category is pre-populated
        $categories.trigger('change');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the questions for joining provisional teams
   *
   * @param categoryId
   * @param teamState
   * @param teamId
   * @param provisionalTeamId
   */
  const loadQuestionsForm = (categoryId, teamState, teamId = null, provisionalTeamId = null) => {
    showLoadingState();

    $.ajax({
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/${categoryId}/questions`,
      type: 'GET',
      data: {
        teamId,
        provisionalTeamId,
        teamState,
      },
    })
      .always(() => hideLoadingState())

      .done((response) => {
        const $questions = $pluginContainer.find('.js-team-questions').html(response);
        initializeTeamQuestions($questions);
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  const fetchPreferredFundraisingOrganizationSelectionForTeam = (teamId, isProvisional) => {
    showLoadingState();

    const baseUrl = `${settings.registrationUrl}/registrant/${settings.registrantIndex}`;

    $.ajax({
      url: `${baseUrl}/team/${teamId}/get-preferred-fundraising-organization-selection`,
      type: 'GET',
      data: {
        isProvisional,
      },
    })
      .always(() => hideLoadingState())

      .done((response) => {
        $pluginContainer.find('.js-team-preferred-fundraising-organization-display')
          .html(response).removeClass('hidden');
      })

      .fail(() => {
        clearPreferredFundraisingContainer();
      });
  };

  /**
   * Load forms when team state changes
   */
  const changeTeamState = function changeTeamState() {
    const $this = $(this);
    const teamState = $this.val();

    // If joining and existing team or creating a new team, we need to load category selection
    if (['joining-existing', 'creating', 'joining-reserved'].includes(teamState)) {
      // Remove the already loaded forms
      clearContainers();

      // Load the categories
      loadCategories(teamState);
    } else if (teamState.includes('join-pre-selected')) {
      fetchPreferredFundraisingOrganizationSelectionForTeam(
        parseInt(teamState.replace('join-pre-selected-', ''), 10),
        false,
      );
    } else if (teamState !== 'no-team') {
      // Remove the already loaded forms
      clearContainers();

      // Otherwise, we can assume the team has been selected and we know the category
      // The category ID is stored on the provisional team options
      const categoryId = parseInt($this.data('category-id'), 10);
      const teamId = parseInt($this.data('team-id'), 10);
      const isProvisional = !!$this.data('is-provisional');

      // Load the questions for the team
      loadQuestionsForm(
        categoryId,
        teamState,
        !isProvisional ? teamId : null,
        isProvisional ? teamId : null,
      );

      // fetch preferred fundraising orgs, if any exist
      if (parseInt($this.data('has-preferred-fundraising-provider-selection'), 10) === 1) {
        fetchPreferredFundraisingOrganizationSelectionForTeam(teamId, isProvisional);
      } else {
        clearPreferredFundraisingContainer();
      }
    } else {
      // Remove the already loaded forms
      clearContainers();
    }
  };

  /**
   * Toggle the password field for the selected team joining
   */
  const togglePassword = ($input) => {
    const $existingTeam = $input.find('option:selected');
    const $password = $pluginContainer.find('.js-joining-team-password');
    const hasPassword = $existingTeam.data('password');

    // Toggle the display and disabled state of the password field base on if the existing team has a password
    $password.toggleClass('hidden', !hasPassword).prop('disabled', !hasPassword);
  };

  /**
   * If the selected team has preferred fundraising organizations, go get em
   */
  const maybeFetchPreferredFundraisingOrganizations = ($input, isProvisional) => {
    const $selected = $input.find(':selected');
    const value = $selected.val();

    if (parseInt($selected.data('has-preferred-fundraising-provider-selection'), 10) === 1) {
      fetchPreferredFundraisingOrganizationSelectionForTeam(value, isProvisional);
    } else {
      clearPreferredFundraisingContainer();
    }
  };

  /**
   * Do all the things that need to happen when the team selector changes
   */
  const reactToTeamSelection = () => {
    const $input = $pluginContainer.find('.js-teams-join-form-control');
    const value = $input.val();
    const isProvisional = !!$input.data('is-provisional');

    togglePassword($input);
    maybeFetchPreferredFundraisingOrganizations($input, isProvisional);

    if (value) {
      loadQuestionsForm(
        $input.data('category'),
        $input.data('team-state'),
        isProvisional ? null : value,
        isProvisional ? value : null,
      );
    }
  };

  /**
   * A horribly hacky way to make select2 render filtered team options 50 at a time with
   * infinite scrolling. My deepest regrets and apologies to whoever winds up having to debug
   * through this absolute disaster of a rotten jQuery soup.
   * @param teams
   * @param $teamSelector
   * @param language
   */
  const setupAdvancedTeamSelector = (teams, $teamSelector, language) => {
    $.fn.select2.amd.require([
      'select2/data/array',
      'select2/utils',
    ], (ArrayData, Utils) => {
      function CustomData($element, options) {
        /* eslint-disable-next-line */
                CustomData.__super__.constructor.call(this, $element, options);
      }

      Utils.Extend(CustomData, ArrayData);

      CustomData.prototype.query = (params, callback) => {
        const pageSize = 50;

        if (!('page' in params)) {
          params.page = 1;
        }

        const filteredTeams = ('term' in params && params.term.length)
          ? teams.filter((team) => {
            if (!team.text || !team.id) {
              return false;
            }

            if (team.text.toLowerCase().includes(params.term.trim().toLowerCase())) {
              return true;
            }

            return false;
          })
          : [];

        const filteredResultsPage = filteredTeams.slice((params.page - 1) * pageSize, params.page * pageSize);

        const data = {
          results: filteredResultsPage,
          pagination: {
            more: params.page * pageSize < filteredTeams.length,
          },
        };

        callback(data);
      };

      $teamSelector
        .on('change', (event) => {
          const $input = $(event.currentTarget);
          event.stopPropagation();
          const value = $input.val();

          if (value) {
            const teamId = parseInt(value, 10);
            const selectedTeam = teams.find((team) => team.id === teamId);

            if (selectedTeam) {
              $input
                .find(':selected')
                .attr('data-password', selectedTeam.hasPassword ? '1' : '0')
                .attr('data-password-pre-authenticated', selectedTeam.preAuthenticated ? '1' : '0')
                .attr(
                  'data-has-preferred-fundraising-provider-selection',
                  selectedTeam.hasPreferredFundraisingSelection ? '1' : '0',
                );
            }
          }

          reactToTeamSelection();
        })
        .select2({
          ajax: {},
          dataAdapter: CustomData,
          language,
        });
    });
  };

  /**
   * Decodes HTML entities. Using a textarea value ensures HTML tags don't make it through
   * @param encodedString
   * @returns {string}
   */
  const decodeEntities = (encodedString) => {
    const textArea = document.createElement('textarea');

    textArea.innerHTML = encodedString;

    const { value } = textArea;

    textArea.remove();

    return value;
  };

  /**
   * Sets up the team selector. If the backend responds with a teams object, that means
   * we need the advanced setup. Otherwise just add select2 if there are more than 10 teams,
   * otherwise just a regular ol' select.
   * @param response
   */
  const setupTeamSelection = (response) => {
    const $teamSelector = $pluginContainer.find('.js-teams-join-form-control');
    const $options = $teamSelector.find('option').not('[data-js-placeholder]');
    const selectedTeam = $teamSelector.val();
    const language = {
      loadingMore: () => settings.i18n.loading,
      noResults: () => {
        // this is hacky but there really isn't any other choice
        // if the search box has something typed into it
        if (!$('[aria-controls="select2-teams-join-existing-results"]').val()) {
          return decodeEntities(settings.i18n.searchByTeamName);
        }

        return settings.i18n.noResultsFound;
      },
      searching: () => settings.i18n.loading,
    };

    if ('teams' in response) {
      const teams = Object
        .values(response.teams)
        .map((team) => ({
          ...team,
          text: team.name,
          disabled: team.isDisabled,
        }))
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }

          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });

      setupAdvancedTeamSelector(teams, $teamSelector, language);
    } else if ($options.length >= 10) {
      $teamSelector.select2({
        language,
      });
    }

    if (selectedTeam) {
      $teamSelector.trigger('change');
    }
  };

  /**
   * Load the join existing teams form
   *
   * @param categoryId
   */
  const loadJoinExistingForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      /* eslint-disable-next-line max-len */
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/${categoryId}/join/joining-existing`,
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $form = $pluginContainer.find('.js-team-join-existing').html(response.html);

        setupTeamSelection(response);

        $form.questionsPlugin({
          registrationPlugin: settings.registrationPlugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
        });
        $form.questionsPlugin('initializeContent');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the join reserved teams form
   *
   * @param categoryId
   */
  const loadJoinReservedForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      /* eslint-disable-next-line max-len */
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/${categoryId}/join/joining-reserved`,
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $form = $pluginContainer.find('.js-team-join-reserved').html(response.html);

        setupTeamSelection(response);

        $form.questionsPlugin({
          registrationPlugin: settings.registrationPlugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
        });
        $form.questionsPlugin('initializeContent');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the create team form
   *
   * @param categoryId
   */
  const loadCreateForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/teams/${categoryId}/create`,
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $createForm = $pluginContainer.find('.js-team-create-new').html(response);

        $createForm.find('input[name="teams[team-name]"]').on('change', validateTeamName);

        loadQuestionsForm(categoryId, 'creating');

        const $preferredCharitySelect = $pluginContainer.find('.js-team-charity-select');
        const maxCharities = $preferredCharitySelect.data('maximum-charities');

        $preferredCharitySelect.select2({
          width: 'resolve',
          maximumSelectionLength: maxCharities,
        });
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Select the team category
   */
  const loadTeamForms = function loadTeamForms() {
    const $this = $(this);
    const categoryId = parseInt($this.val(), 10);
    const teamState = $teamStates.filter(':checked').val();

    // Do nothing if the category is not valid
    if (Number.isNaN(categoryId) || categoryId < 1) {
      return;
    }

    // Clear out the create and join existing forms when switching categories
    $pluginContainer
      .find('.js-team-create-new, .js-team-join-existing, .js-team-join-reserved, .js-team-questions')
      .empty();

    // For joining, load the join existing form when the category is selected
    if (teamState === 'joining-existing') {
      loadJoinExistingForm(categoryId);
    }

    // For joining a reserved team, load the form when the category is selected
    if (teamState === 'joining-reserved') {
      loadJoinReservedForm(categoryId);
    }

    // For creating, load the create form when the category is selected
    if (teamState === 'creating') {
      loadCreateForm(categoryId);
    }
  };

  const Plugin = function teamsPlugin(element, options) {
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      registrationUrl: null,
      registrantIndex: 1,
      registrantsPersonalInformation: null,
    };

    /*
     * Initialization
     */
    settings = $.extend(this.settings, options);

    // Set the container for the plugin
    $pluginContainer = element;
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  /**
   * Display the plugin's contents
   *
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    // sometimes the content already exists in the html, so we can skip this
    if (content) {
      $pluginContainer.html(content);
    }

    $teamStates = $pluginContainer.find('input[name="teams[state]"]');
    $teamSpinner = $pluginContainer.find('#team-spinner');

    const $preferredCharitySelect = $pluginContainer.find('.js-team-charity-select');
    const maxCharities = $preferredCharitySelect.data('maximum-charities');
    const $teamStateInput = $teamStates.filter('input[type="hidden"]');

    $preferredCharitySelect.select2({
      width: 'resolve',
      maximumSelectionLength: maxCharities,
    });

    // Binding for team state change
    $teamStates.on('change', changeTeamState);

    // Load the team forms on team category selection
    $pluginContainer.on('change', ':input[name="teams[category]"]', loadTeamForms);

    // Toggle the password field on existing/reserved team join change
    $pluginContainer.on('change', '.js-teams-join-form-control', reactToTeamSelection);

    // Trigger change for the joined existing/reserved team if pre-populated
    // this will toggle display of the password field
    $pluginContainer.find('.js-teams-join-form-control').trigger('change');

    // Bind team name validation for pre-populated create form
    $pluginContainer.find('input[name="teams[team-name]"]').on('change', validateTeamName);

    initializeTeamQuestions($pluginContainer.find('.js-team-questions'));

    if ($teamStateInput.length) {
      $teamStates.trigger('change');
    }
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
